const signalRServerEventName = {
  JOIN_TENANT_GROUP: 'JoinTenantGroup',
  NOTIFY_PUBLIC_TRAY_UPDATE: 'NotifyPublicTrayUpdate',
};

export default signalRServerEventName;
